import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import LoginPage from "./LoginPage";
import RegisterPage from "./RegisterPage";

const AuthPage: React.FC = () => {
  const [page, setPage] = useState<"login" | "register">("login");
  const [showSuccess, setShowSuccess] = useState(false);
  const navigate = useNavigate();

  const handleSwitch = (nextPage: "login" | "register", success?: boolean) => {
    setPage(nextPage);
    setShowSuccess(!!success);

    if (success) {
      navigate("/inventory", { replace: true });
    }
  };

  return page === "login" ? (
    <LoginPage onSwitch={handleSwitch} showSuccess={showSuccess} />
  ) : (
    <RegisterPage onSwitch={handleSwitch} />
  );
};

export default AuthPage;